import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import * as XLSX from 'xlsx';

@Injectable({
    providedIn: 'root'
})
export class ExcelExportService {

    constructor(private http: HttpClient) {}


    exportToExcel(payload: any = {}, path: string): Observable<Blob> {

        let params = new HttpParams();
        Object.entries(payload).forEach(([key, val]) => {
            if (val != null && val !== '') {
                let formattedValue = val;

                if (val instanceof Date) {
                    // Format date in local time, not UTC
                    const year = val.getFullYear();
                    const month = String(val.getMonth() + 1).padStart(2, '0');
                    const day = String(val.getDate()).padStart(2, '0');
                    formattedValue = `${year}-${month}-${day}`;
                }

                params = params.set(key, String(formattedValue));
            }
        });

        return this.http
            .get(path, { params, responseType: 'blob' });

    }


}